import { isly } from "isly";
import { Numeric as DayNumeric } from "./Numeric";
export var Day;
(function (Day) {
    var _a;
    Day.Numeric = DayNumeric;
    Day.values = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
    ];
    _a = isly
        .string("value", ...Day.values)
        .rename("isoly.Date.Day")
        .bind(), Day.type = _a.type, Day.is = _a.is, Day.flawed = _a.flawed;
    function create(value) {
        return Day.type.get(value.toString().padStart(2, "0"));
    }
    Day.create = create;
})(Day || (Day = {}));
//# sourceMappingURL=index.js.map